// The official PDF form the app fills (public/formular.pdf).
//
// pdfMappings.js refers to its fields by name, so a new edition of the form
// must be a deliberate change. When the court publishes one:
//   1. replace public/formular.pdf,
//   2. run the tests: pdfTemplate.integration.test.js lists every field name
//      that no longer exists and every income label that stopped matching,
//   3. fix pdfMappings.js / pdfFillers.js / pdfImporter.js accordingly,
//   4. update FORM_EDITION (shown in the footer) and FORM_TEMPLATE_SHA256.
export const FORM_EDITION = '02/2026'

export const FORM_TEMPLATE_SHA256 =
	'9bdd4bdddff424cb08548d1dd35a15e80e9972b8e721d2a60f053d21fbadb900'
